import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AutofilliaService } from '../../../../../shared/services/autofillia.service';
import { RegisterIAService } from '../../../../../shared/services/register-ia.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { catchError, of } from 'rxjs';
import { CaptchaService } from '../../../../../shared/services/captcha.service';
import { CryptoService } from '../../../../../shared/services/crypto.service';

@Component({
  selector: 'app-iapreviewpage',
  templateUrl: './iapreviewpage.component.html',
  styleUrl: './iapreviewpage.component.css'
})
export class IapreviewpageComponent {
  //form1: any;
  termsConditionAccepted: boolean = false;
  formData: any;
  captcha!: string;
  captchaError: boolean = false;
  captchaSuccess: boolean = false;
  
  constructor(private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private ia_serv: AutofilliaService,
    private ia_service: RegisterIAService,
    private captchaService: CaptchaService,
    private toastr: ToastrService, private cryptoService: CryptoService) { }

  form1 = new FormGroup({
    captcha: new FormControl('', [Validators.required,]),
    termsConditionAccepted: new FormControl('', [Validators.required]),
    thirdPartyUndertaking: new FormControl('', [Validators.required]),
  })


  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.formData = history.state.formData;
      this.termsConditionAccepted = this.formData?.termsAccepted || false;
      this.generateCaptcha();
    });

    //back btn data
    //this.formData = {
    //  // example values you want to pass back
      
    //}
  }
  get f() {
    return this.form1.controls;
  }

  goBack() {
    // Pass form data in navigation state
    this.router.navigate(['/iaregister'], {
      state: { formData: this.formData }
    });
  }

  
  //SaveUser2() {
  //  //if (!this.termsConditionAccepted) {
  //  //  alert("You must agree to the Terms & Conditions before submitting.");
  //  //  return;
  //  //}

  //  this.formData = {

  //    NameOfOrganisation: this.formData.orgname,
  //    ShortNameOfOrganisation: this.formData.shortorgname,
  //    AddressOfOrganisation: this.formData.address,
  //    IAUserName:this.formData.username,
  //    Email: this.formData.email,
  //      MobileNumber: this.formData.mobnum,


  //      Password: this.formData.password,


  //    Designation: this.formData.designation,
  //    FocusSectorId: this.formData.focusSectorId,
  //    InterestsId: this.formData.InterestsId,
  //    Intervention: this.formData.Intervention,

  //  };
  //  this.apiService.postRequest(API_ENDPOINTS.IA.SAVEUSER, this.formData).subscribe(response => {
  //    alert("User added successfully. Please login and verify.");
  //    this.router.navigateByUrl("/login");
  //    return response;
  //  }),
  //    catchError(error => {
  //      let errorMessage = "An error occurred during login.";
  //      if (error.status === 409) {
  //        errorMessage = "User already exists";
  //      } else if (error.status === 400) {
  //        errorMessage = "Bad Request";
  //      }
  //      alert(errorMessage);
  //      return of(null);
  //    });
  //}


  SaveUser() {
    /*if*/ (this.form1.valid) /*{*/
      const userinput = this.form1.controls.captcha.value as string;
      if (this.captchaService.validateCaptcha(userinput, this.captcha))
      { 
        if (!this.form1.valid) {
          alert("You must agree to the Terms & Conditions before submitting.");
          return;
        }


      // Create a FormData object
      const formData = new FormData();

      const excludedKeys = ['captcha']; // Add any other keys you want to exclude

       
       //Append form control values dynamically
      Object.keys(this.form1.value).forEach(key => {
        const value = this.form1.get(key)?.value;
        if (value !== null && !excludedKeys.includes(key)) {
          formData.append(key, value);
        }
      });

      Object.keys(this.formData).forEach(key => {
        const value = this.formData[key];
        if (value !== null && !excludedKeys.includes(key)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item individually
            value.forEach((item, index) => {
              // If the item is an object, you might want to stringify it or handle its properties
              if (typeof item === 'object') {
                Object.keys(item).forEach(subKey => {
                  formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
                });
              } else {
                // For primitive types, you can just append them
                formData.append(`${key}[${index}]`, item);
              }
            });
          } else {
            formData.append(key, value);
          }
        }
      });


        //the encrypting part for password
        //const password = this.formData.Password;
        //const encryptedPassword = this.cryptoService.encrypt(password); // Encrypt using CryptoService
        //console.log("Encrypted Password:", encryptedPassword);

        //// Replace plaintext with encrypted value in FormData
        //formData.set('Password', encryptedPassword);

        

       

      this.apiService.postRequest(API_ENDPOINTS.IA.SAVEUSER, formData).pipe(
        
      ).subscribe(response => {
        //if (response.status) {
        //  //this.toastr.warning(response.message);
        //  //alert("Information captured successfully. ");
        //  this.toastr.success("Information captured successfully");
        //  this.router.navigateByUrl("/login");
        //}

        if (response.status) {
          this.toastr.success(response.message);
          this.router.navigateByUrl("/login");
        }
        else {
          this.toastr.error("Some issue occured,try again properly");
          this.router.navigateByUrl("/iaregister");
         
        }
      });
      } else {
        this.captchaError = true;
        this.generateCaptcha();
      }
    
  }
  generateCaptcha(): void {
    this.form1.get('captcha')?.setValue('');
    this.captcha = this.captchaService.generateCaptcha();
    this.drawCaptcha();
  }
  //drawCaptcha(): void {
  //  const canvas: HTMLCanvasElement = document.getElementById('captchaCanvas') as HTMLCanvasElement;
  //  const context = canvas.getContext('2d');
  //  if (context) {
  //    context.clearRect(0, 0, canvas.width, canvas.height);
  //    context.font = '30px sans-serif';
  //    context.fillStyle = '#5e5c5c';
  //    context.fillText(this.captcha, 10, 35);

  //  }
  //}

  //Added by sayali
  drawCaptcha(): void {
    const canvas: HTMLCanvasElement = document.getElementById('captchaCanvas') as HTMLCanvasElement;
    const context = canvas.getContext('2d');

    if (context) {
      // Clear the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);

      // Set font and text color
      context.font = '30px sans-serif';
      context.fillStyle = '#5e5c5c';

      // Calculate text dimensions and padding
      const textWidth = context.measureText(this.captcha).width;
      const textHeight = 30; // Approximate height for 30px font
      const padding = 10; // Padding around the text

      // Define box dimensions
      const boxX = 5;
      const boxY = 5;
      const boxWidth = textWidth + padding * 2;
      const boxHeight = textHeight + padding * 2;

      // Draw the text
      context.fillText(this.captcha, boxX + padding, boxY + textHeight + padding / 2);

      // Draw the box around the text
      context.strokeStyle = '#5e5c5c';
      context.lineWidth = 1;
      context.strokeRect(boxX, boxY, boxWidth, boxHeight);
    }
  }

  onReset() {
    this.form1.reset();
    sessionStorage.clear();
  }
  navigateBack() {
    this.router.navigate(['/iaregister'], { state: { formData: this.formData } });
  }
}
